import React from "react";

import AppModal from "../AppModal";
import { i18n } from "../../translate/i18n";

export function VariablesModal({
	open,
	handleClose,
	variables,
	scheduleData,
	setScheduleData,
}) {
	return (
		<AppModal
			open={open}
			onClose={handleClose}
			title={i18n.t("scheduleModal.variablesTitle")}
			maxWidth={460}
			footer={
				<button
					type="button"
					className="btn btn-sub-gray"
					onClick={handleClose}
				>
					{i18n.t("scheduleModal.buttons.cancel")}
				</button>
			}
		>
			<div className="space-y-4">
				<p className="m-0 text-sm text-default-500 dark:text-default-400">
					{i18n.t("scheduleModal.form.messageHint")}
				</p>
				<div className="flex flex-wrap gap-2">
					{variables.map((variable) => (
						<button
							key={variable}
							type="button"
							className="btn btn-sm bg-primary/10 text-primary hover:bg-primary/20"
							onClick={() => {
								setScheduleData({
									...scheduleData,
									body: `${scheduleData.body || ""}${variable}`,
								});
								handleClose();
							}}
						>
							{variable}
						</button>
					))}
				</div>
			</div>
		</AppModal>
	);
}
